<template>
    <Header class="main-header">
        <template slot="head">
            <a-button v-if="mobile" class="drawer-handler"
                icon="unordered-list" @click="showDrawer" 
            ></a-button>
            <a-drawer v-if="mobile"
                placement="left"
                :closable="false" :visible="visible"
                @close="onClose"
            >
                <a-menu :defaultSelectedKeys="[ nowtab ]" mode="inline" :selectable="false" class="main-tab">
                    <a-menu-item v-for="tab of tabs" :key="tab.key">
                        <a :href="tab.link">{{ tab.name }}</a>
                    </a-menu-item>
                    <!-- <a-menu-item @click="toOld">返回旧版</a-menu-item> -->
                </a-menu>
            </a-drawer>
        </template>
        <template slot="center">
            <a-menu v-if="!mobile" :defaultSelectedKeys="[ nowtab ]" mode="horizontal" :selectable="true" class="main-tab">
                <a-menu-item v-for="tab of tabs" :key="tab.key">
                    <a :href="tab.link">{{ tab.name }}</a>
                </a-menu-item>
            </a-menu>
        </template>
        <!-- <template slot="tail">
            <div class="to-old" v-if="!mobile">
                <a-button type="primary" shape="round" size="small" @click="toOld">回到旧版</a-button>
            </div>
        </template> -->
    </Header>
</template>

<script>
import { MAIN_PAGES } from '../constant';
import Header from "./Header.vue";

const handle = window.matchMedia('(max-width: 599px)');

export default {
    props: {
        nowtab: { type: String, default: "" },
    },
    data: () => ({
        tabs: MAIN_PAGES,
        visible: false,
        mobile: handle.matches,
    }),
    created() {
        handle.onchange = (e) => this.mobile = e.matches;
    },
    methods: {
        toOld() {
            localStorage.setItem('prefer', 'new');
        },
        showDrawer() {
            this.visible = true;
        },
        onClose() {
            this.visible = false;
        },
    },
    components: {
        Header
    }
}
</script>

<style lang="less" scoped>
.main-header {
    background: #FFFFFF;
    height: 52px;
    line-height: 52px;
}
.main-tab {
    margin: -1px auto 1px;
    border-bottom: none;
}
.to-old {
    display: flex;
    align-items: center;
    margin-left: 8px;
}
.drawer-handler {
    align-self: center;
    margin-right: 5px;
}
</style>

<style scoped>
.main-header >>> .site-brand .logo {
    color: black;
}
.main-header >>> .user .username {
    color: #444444;
}
.ant-drawer >>> .ant-drawer-body {
    padding: 0px;
}
</style>